const LEGACY_VILLAGES_CDN_BASE = "https://cdn.jsdelivr.net/gh/DevrajKalpure/PracticeGithub@main";
const DEFAULT_VILLAGES_CDN_BASE = `${LEGACY_VILLAGES_CDN_BASE}/data`;
const RAW_VILLAGES_BASE = "https://raw.githubusercontent.com/DevrajKalpure/PracticeGithub/main";
const RAW_VILLAGES_DATA_BASE = `${RAW_VILLAGES_BASE}/data`;
const LOCAL_VILLAGES_BASE = "/data";
const FETCH_TIMEOUT_MS = 15000;

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function buildCandidates() {
  const configured = trimTrailingSlash(process.env.REACT_APP_VILLAGES_CDN_BASE || "");
  const candidates = [];

  if (configured) {
    if (configured.endsWith("/data")) {
      candidates.push(configured);
    } else {
      candidates.push(`${configured}/data`);
    }
  }

  // Prefer raw GitHub first; jsDelivr can intermittently 403.
  candidates.push(RAW_VILLAGES_DATA_BASE, DEFAULT_VILLAGES_CDN_BASE, LOCAL_VILLAGES_BASE);

  return Array.from(new Set(candidates.map(trimTrailingSlash).filter(Boolean)));
}

function buildUrl(base, filePath) {
  return `${base}/${String(filePath || "").replace(/^\/+/, "")}`;
}

async function fetchWithTimeout(url, init = {}, timeoutMs = FETCH_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      cache: "force-cache",
      ...init,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timer);
  }
}

export async function fetchVillageResponse(filePath, init = {}) {
  const candidates = buildCandidates();
  let lastError = null;

  for (const base of candidates) {
    const url = buildUrl(base, filePath);
    try {
      const response = await fetchWithTimeout(url, init);
      if (response.ok) return response;
      lastError = new Error(`HTTP ${response.status} for ${url}`);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error(`Failed to fetch ${filePath}`);
}

export async function fetchVillageJson(filePath, init = {}) {
  const response = await fetchVillageResponse(filePath, init);
  return response.json();
}

export async function villageFileExists(filePath) {
  try {
    await fetchVillageResponse(filePath, { method: "HEAD" });
    return true;
  } catch (_) {
    return false;
  }
}

export function getVillageDataBase() {
  return buildCandidates()[0];
}
